import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Cursor from './components/Cursor';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ProjectGallery from './components/ProjectGallery';
import './index.css';

function MainPage({ loading, setLoading }) {
  return (
    <>
      
        <>
          <Navbar />
          <Hero />
          <About />
          <Projects />
          <Testimonials />
          <Contact />
          <Footer />
        </>
      
    </>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      offset: 80,
    });
  }, []);

  return (
    <div>
      <Cursor />
      <Routes>
        <Route path="/" element={
          <MainPage loading={loading} setLoading={setLoading} />
        } />
        <Route path="/projects/:category" element={<ProjectGallery />} />
      </Routes>
    </div>
  );
}

export default App;